import React, { useState } from 'react';

import { Avatar, Date, OnlineStatus, Separator } from '../../components';

import { MerchantDetailsRow } from './MerchantDetailsRow';

export function MerchantRow({ item }) {
  const [merchant, setMerchant] = useState(item)
  const [expanded, setExpanded] = useState(false)

  const onClick = (e) => {
    e.preventDefault()

    setExpanded(!expanded)
  };

  const merchantId = 'M' + String(merchant.id).padStart(4, '0');

  const avatarBlock = (
    <div className="avatar-with-status">
      <Avatar
        fileId={merchant.avatar_file_id}
        onClick={onClick}
      />

      <OnlineStatus lastActiveDate={merchant.user?.last_active_at} />
    </div>
  );

  return (
    <>
      <tr className={`mobile ${expanded ? 'expanded' : ''} merchant-row`}>
        <td>
          <div className="contact">
            <div className="d-flex justify-content-between contact-content">
              <div className="d-flex justify-content-start">
                {avatarBlock}
              </div>
              <div className="ml-2 align-self-center" style={{ textAlign: 'left'}}>
                <a className="name" href="" onClick={onClick}>
                  { (merchant.first_name || merchant.last_name) ? (merchant.first_name + " " + merchant.last_name) : merchant.email }
                </a>

                <br/>
                <span>{merchantId}</span>
              </div>
            </div>
          </div>

          <Separator noMargin className="my-0" />

          <div className="d-flex justify-content-between merchant-content">
            <div>
              <label>Subscription</label>
              <div>Plan X</div>
              <div><Date date={merchant.subscription_expiry || new window.Date()} /></div>
            </div>

            <div className="expanded-status" onClick={onClick} />
          </div>
        </td>
      </tr>

      <tr className={`desktop ${expanded ? 'expanded' : ''}`}>
        <td className="expanded-status" onClick={onClick}>
        </td>
        <td>
          {avatarBlock}
        </td>
        <td className="name">
          <a href="" onClick={onClick}>
            { (merchant.first_name || merchant.last_name) ? (merchant.first_name + " " + merchant.last_name) : merchant.email }
          </a>
        </td>
        <td className="birth-date">
          {merchantId}
        </td>
        <td className="turnover uppercase">
          {merchant.active_plan}
        </td>
        <td className="last-active">
          {merchant.merchant_store?.current_period_end && (
            <Date date={merchant.merchant_store?.current_period_end} />
          )}
        </td>
      </tr>

      {expanded && (
        <MerchantDetailsRow
          merchant={merchant}
          onMerchantUpdated={(merchant) => setMerchant(merchant)}
        />
      )}
    </>
  );
}
